import {Column} from '../models/components/EfeTableValues';
import {LogDetail, LogErrors} from '../models/dtos/logs/Logs';
import {ClientDataResponse} from '../models';

export const ERRORS: Array<Column> = [
    {
        columnDef: 'processId',
        header: 'Id',
        headerType: 'text',
        cell: (log: LogErrors) => log.processId,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'processKey',
        header: 'Proceso',
        headerType: 'text',
        cell: (log: LogErrors) => log.processKey,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'initialProcessDate',
        header: 'Fecha',
        headerType: 'text',
        cell: (log: LogErrors) => (log.initialProcessDate ? log.initialProcessDate : ''),
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'uploadFileName',
        header: 'Archivo',
        headerType: 'text',
        cell: (log: LogErrors) => (log.uploadFileName ? log.uploadFileName : ''),
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'errorMessage',
        header: 'Error',
        headerType: 'text',
        cell: (log: LogErrors) => (log.errorMessage ? log.errorMessage : ''),
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'action',
        header: 'Detalle',
        headerType: 'text',
        cell: (log: LogErrors) => log,
        cellType: 'action',
        actionDescription: 'Ver',
        status: false,
        minWidth: true,
    },
];

export const ERROR_DETAIL: Array<Column> = [
    {
        columnDef: 'registerId',
        header: 'Id',
        headerType: 'text',
        cell: (log: LogDetail) => log.registerId,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'errorDetails',
        header: 'Detalle',
        headerType: 'text',
        cell: (log: LogDetail) => log.errorDetails,
        cellType: 'text',
        status: false,
        minWidth: true,
    }
];
